











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MainContainer from '@/components/Pages/MainContainer.vue';
import BottomBar from '@/components/Partials/BottomBar/BottomBar.vue';
import Snackbar from '@/components/Partials/Snackbar.vue';
import CookiesInfo from '@/components/Partials/CookiesInfo.vue';
import TopBarDesktop from './components/Partials/TopBar/TopBarDesktop.vue';
import TopBarMobile from './components/Partials/TopBar/TopBarMobile.vue';
import './css/app.css';

@Component({
  components: {
    CookiesInfo,
    Snackbar,
    BottomBar,
    TopBarDesktop,
    TopBarMobile,
    MainContainer,
  },
})
export default class App extends Vue {
// private translations: TranslationsInterface = translations[store.state.language]
}
